import { render } from "./SectionShiftingSchedule.vue?vue&type=template&id=5494560f&scoped=true"
import script from "./SectionShiftingSchedule.vue?vue&type=script&lang=js"
export * from "./SectionShiftingSchedule.vue?vue&type=script&lang=js"

import "./SectionShiftingSchedule.vue?vue&type=style&index=0&id=5494560f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5494560f"]])

export default __exports__